// extracted by mini-css-extract-plugin
module.exports = {"colorBlock":"styles_colorBlock__2yAsI","black":"styles_black__1nAuE","gray":"styles_gray__1hjjL","disabled":"styles_disabled__3g-Wo"};